export const ErrorMessagesMap = new Map<string, string>();
ErrorMessagesMap.set('Sandbox Error: username reserved', 'That username is reserved. Please try a different one.');

export function getFriendlyErrorMessage(message = '') {
  if (ErrorMessagesMap.has(message)) {
    return ErrorMessagesMap.get(message);
  }
  return message;
}
